export default {
    "Citrix AppDNA" : "Citrix Virtual Apps",
    "Citrix Bytemobile" : "Citrix ADC",
    "Citrix Cloud Lifecycle Management" : "Citrix Workspace",
    "Citrix CloudPortal Business Manager" : "Citrix Virtual Apps and Desktops service",
    "Citrix CloudPortal Services Manager" : "Citrix Virtual Apps and Desktops service",
    "Citrix DesktopPlayer" : "Citrix Virtual Apps and Desktops service",
    "Citrix Hypervisor Free Download" : "Citrix Hypervisor",
    "Citrix VDI-in-a-Box" : "Citrix Virtual Apps and Desktops service",
    "Citrix XenApp" : "Citrix Virtual Apps",
    "Citrix NetScaler Gateway" : "Citrix Gateway",
    "Citrix NetScaler" : "Citrix ADC",
    "Citrix NetScaler AppFirewall" : "Citrix Web App Firewall",
    "Citrix NetScaler SD-WAN" : "Citrix SD-WAN",
    "Citrix XenServer" : "Citrix Hypervisor",
    "Citrix XenDesktop" : "Citrix Virtual Desktops",
    "Citrix XenServer Free Download" : "Citrix Hypervisor Free Download",
    "Citrix ShareFile" : "Citrix Content Collaboration",
    "Citrix XenMobile" : "Citrix Endpoint Management",
    "Citrix Workspace Suite" : "Citrix Workspace",
    "Citrix NetScaler Gateway Service" : "Citrix Gateway service",
    "Citrix XenMobile Service" : "Citrix Endpoint Management service",
    "Citrix XenDesktop Service" : "Citrix Virtual Desktops service",
    "Citrix XenApp and XenDesktop Service" : "Citrix Virtual Apps and Desktops service",
    "Citrix Workspace Service" : "Citrix Workspace service",
    "Citrix App Layering" : "Citrix App Layering",
    "Citrix XenApp Service" : "Citrix Virtual Apps service",
    "Citrix ShareFile Service" : "Citrix Content Collaboration service",
    "Citrix NetScaler Service" : "Citrix Networking feature service"
}